import { useState, useEffect } from "react";
import "./video.css";
import YouTube from "react-youtube";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlay } from "@fortawesome/free-solid-svg-icons";

const Video = ({ name = "", poster = "", youtube }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const onReady = (event) => {
    const player = event.target;
    player.playVideo();
  };

  return (
    <div className="embed-video-clip">
      {isPlaying && (
        <YouTube
          key={`${youtube.id}`}
          videoId={youtube.id}
          onReady={onReady}
          opts={{
            playerVars: {
              autoplay: 1,
              mute: 0,
              start: youtube.start,
              end: youtube.end,
              cc_load_policy: 1, // forces captions ON
              hl: "en", // sets UI language
            },
          }}
          className="youtube-iframe"
          style={{
            opacity: isPlaying ? 1 : 0,
            transition: "opacity 0.4s ease",
          }}
        />
      )}

      {!isPlaying && (
        <div
          className="embed-video-clip-preview"
          onClick={() => setIsPlaying(true)}
        >
          {poster !== "" && <img src={poster} alt="Showcase Preview Poster" />}
          <div className="play-btn-wrapper">
            <FontAwesomeIcon
              icon={faCirclePlay}
              color="#fff"
              className="play-btn"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Video;
